export const MANAGED_QUOTE_TEMPLATE_TYPES = new Set(['CUSTOMIZABLE_QUOTE_TEMPLATE', 'CPQ_QUOTE']);
export const isManagedQuoteTemplateType = templateType => MANAGED_QUOTE_TEMPLATE_TYPES.has(templateType);